<template>
  <div
    v-if="entry.id && entry.play_after_entry"
    class="mt-1"
    :title="tooltip"
  >
    <v-icon
      color="msr"
      class="mr-1"
      small
    >
      link
    </v-icon>
    <small class="msr--text">{{ entry.play_after_entry.spot.title }}</small>
  </div>
</template>

<script>
export default {
  name: 'PlayAfterEntryStatus',
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tooltip() {
      const template = this.$t('linkContentsCurrentlyLinkedTo');
      return template.replace(
        '{{ linkedTo }}',
        this.entry.play_after_entry.spot.title
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PlayAfterEntryStatus.vue